export const refs = {
  searchForm: document.querySelector('.search__form'),
  movieList: document.querySelector('.gallery__list'),
  modalBtns: document.querySelector('.btn_wraper'),

  switchColorCheckbox: document.querySelector('.menu-switch__check'),

  listOfGenres: document.querySelector('#genres'),

  libraryFilter: document.querySelector('.library-filter'),
  watchedBtn: document.querySelector('[data-watched]'),
  queueBtn: document.querySelector('[data-queue]'),
  search: document.querySelector('.search'),
  libraryBtn: document.querySelector('[data-library]'),
  homeBtn: document.querySelector('[data-home]'),
  logo: document.querySelector('.logo__container'),
  gallery: document.querySelector('.gallery-section'),
  pagEl: document.querySelector('.pagination-wrap'),
  filterContainer: document.querySelector('.filter-container'),
  galleryMain: document.querySelector('.gallery__list'),
  galleryLibrary: document.querySelector('.gallery__list--library'),

  genreSelector: document.querySelector('.filter-genre'),
  textSearchError: document.querySelector('.hero__search-error'),
  gallerySection__gallery: document.querySelector('.gallery'),
  wached: document.querySelector('.modal_card_btn.wached'),
  queue: document.querySelector('.modal_card_btn.queue'),
  pagination: document.querySelector('.pagination'),
  openVideoBtn: document.querySelector('.open__video_bnt'),
  smaiImage: document.querySelector('.empty__request'),
  trailerBtnWraper: document.querySelector('.trailerBtnWraper'),
  poster: document.querySelector('.poster'),
  btnToTop: document.querySelector('.btn-to-top__link'),
  footerContainer: document.querySelector('.footer'),
  footerBtn: document.querySelector('.footer__button'),
};
